import { UserSearchComponent } from "./components/users/user-search/user-search.component";
import { Routes } from "@angular/router";
import { OffersComponent } from "./components/offers/offers/offers.component";
import { TargetGroupsComponent } from "./components/target-groups/target-groups/target-groups.component";
import { ComponentRoutes } from "./models/constants/component-routes";
import { authorizedGuard } from "./guards/authorized.guard";
import { SignInComponent } from "./components/auth/sign-in/sign-in.component";
import { OfferComponent } from "./components/offers/offer/offer.component";
import { TargetGroupComponent } from "./components/target-groups/target-group/target-group.component";
import { OfferGoalsChallengesComponent } from "./components/offers/offer-goals-challenges/offer-goals-challenges.component";
import { AchievementsComponent } from "./components/achievements/achievements/achievements.component";
import { AchievementComponent } from "./components/achievements/achievement/achievement.component";
import { QuestsManagerComponent } from "./components/quests/quests-manager/quests-manager.component";
import { QuestTemplateComponent } from "./components/quests/templates/quest-template/quest-template.component";
import { QuestComponent } from "./components/quests/quest/quest.component";
import { UserComponent } from "./components/users/user/user.component";
import { OfferStatisticsComponent } from "./components/offers/offer-statistics/offer-statistics.component";
import { SpinWheelComponent } from "./components/spin-wheel/spin-wheel/spin-wheel.component";
import { BannersComponent } from "./components/banners/banners.component";
import { AbTestsComponent } from "./components/ab-tests/ab-tests/ab-tests.component";
import { AbTestComponent } from "./components/ab-tests/ab-test/ab-test.component";
import { HealthComponent } from "./components/health/health.component";
import { ClientsComponent } from "./components/clients/clients/clients.component";

export const routes: Routes = [
    { path: "", redirectTo: ComponentRoutes.offers.root, pathMatch: "full" },
    {
        path: ComponentRoutes.health.root,
        component: HealthComponent,
    },
    {
        path: ComponentRoutes.auth.root,
        component: SignInComponent,
    },
    {
        path: ComponentRoutes.offers.root,
        component: OffersComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.offers.offer,
        component: OfferComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.offers.offerGoals,
        component: OfferGoalsChallengesComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.clients.root,
        component: ClientsComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.targetGroups.root,
        component: TargetGroupsComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.targetGroups.group,
        component: TargetGroupComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.achievements.root,
        component: AchievementsComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.achievements.achievement,
        component: AchievementComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.quests.root,
        component: QuestsManagerComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.quests.quest,
        component: QuestComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.quests.template,
        component: QuestTemplateComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.users.root,
        component: UserSearchComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.users.user,
        component: UserComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.offers.statistics,
        component: OfferStatisticsComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.spinWheel.root,
        component: SpinWheelComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.banners.root,
        component: BannersComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.abTests.root,
        component: AbTestsComponent,
        canActivate: [authorizedGuard],
    },
    {
        path: ComponentRoutes.abTests.test,
        component: AbTestComponent,
        canActivate: [authorizedGuard],
    },
];
